import '@babel/polyfill';
import 'element-closest-polyfill';
import dialogPolyfill from 'dialog-polyfill';
import {
  Configurator,
  createBreakerboardsInstallation,
  createMinimalData,
  Requester,
  EditState,
} from './steps/configurator';
import FacingConfigurator from './steps/facing/facing-configurator';
import PackageCalculator from './steps/packages/package-calculator';
import PackageFiltering from './steps/packages/package-filtering';
import PackageSorting from './steps/packages/package-sorting';
import PackageComparing from './steps/packages/package-comparing';
import EventTracking from './libs/parkside/event-tracking';
import IFrameHandler from './iframe-handler';
import CustomerDataHandler from './steps/itemlist';
import { HeightsConfigurator } from './steps/heights';
import { Questionnaire } from './steps/questions';
import { DownloadSelectionDialog } from './steps/pdf-select/pdf-select';
import FilterQuestionnaire from './steps/filter-questionnaire/filter-questionnaire';
import { DialogBase } from './steps/utils/dialog-handler.js';

require('./common-interactions.js');
require('./steps/abdeckleisten.js');
require('./steps/deckform.js');
require('./steps/dielenart.js');
require('./steps/grundriss.js');
require('./steps/pakete.js');
require('./steps/rotation.js');
require('./steps/fixations.js');
require('./steps/zubehoer.js');
require('./steps/overview.js');

window.dialogPolyfill = dialogPolyfill;
window.Configurator = Configurator;
window.createBreakerboardsInstallation = createBreakerboardsInstallation;
window.createMinimalData = createMinimalData;
window.Requester = Requester;
window.EditState = EditState;
window.FacingConfigurator = FacingConfigurator;
window.PackageCalculator = PackageCalculator;
window.EventTracking = EventTracking;
window.IFrameHandler = IFrameHandler;
window.PackageFiltering = PackageFiltering;
window.PackageSorting = PackageSorting;
window.PackageComparing = PackageComparing;
window.CustomerDataHandler = CustomerDataHandler;
window.HeightsConfigurator = HeightsConfigurator;
window.Questionnaire = Questionnaire;
window.DownloadSelectionDialog = DownloadSelectionDialog;
window.FilterQuestionnaire = FilterQuestionnaire;
window.DialogBase = DialogBase;
